import { AloftArea, AloftPrice, PairedCostFeatures } from '@aloft/toolkit-shared';

import { Tkv2PairedCostSummaryInterfaceV2 } from '../../types.ts';

const getChartDataFromFeatures = (features?: PairedCostFeatures) => {
  const siteSize = features?.site?.siteValue?.sqft.toSqFt().getUnitAmount();
  const siteValue = features?.site?.siteValue?.totalCost.toDollarLike();
  return { siteSize, siteValue };
};

export const getSiteSizeVsSiteValueChartData = (
  props: Tkv2PairedCostSummaryInterfaceV2 | null,
  compSequence: string[] | undefined,
  siteSizes: Record<string, AloftArea | undefined>,
  siteValues: Record<string, AloftPrice | undefined>,
) => {
  const data: {
    siteName: string;
    siteSize: number | undefined;
    siteValue: number | undefined;
  }[] = [];

  if (props) {
    const subjectFeatures = props.results?.subject?.features;
    data.push({ siteName: 'SUB', ...getChartDataFromFeatures(subjectFeatures) });

    props.compSequence.forEach((compId, idx) => {
      const compFeatures = props.results.comps[compId]?.features;
      data.push({ siteName: `CP${idx + 1}`, ...getChartDataFromFeatures(compFeatures) });
    });
  } else if (compSequence) {
    data.push({
      siteName: 'SUB',
      siteSize: siteSizes['subject']?.toSqFt().getUnitAmount(),
      siteValue: siteValues['subject']?.toDollarLike(),
    });

    compSequence.forEach((compId, idx) => {
      data.push({
        siteName: `CP${idx + 1}`,
        siteSize: siteSizes[compId]?.toSqFt().getUnitAmount(),
        siteValue: siteValues[compId]?.toDollarLike(),
      });
    });
  }

  return data.sort((a, b) => (a.siteSize ?? 0) - (b.siteSize ?? 0));
};
